/**
 * List of category page navigation paths (and their children) that are eligible to render with SDUI
 */
export const WEB_SDUI_CATEGORY_PAGE_NAVIGATION_PATHS = 'WEB_SDUI_CATEGORY_PAGE_NAVIGATION_PATHS';
